module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"type-private":"Privatperson","type-company":"Firma","field-company":"Firmaname","field-department":"Abteilung","title-fem":"Frau","title-masc":"Herr","field-firstname":"Vorname","field-lastname":"Name","field-street":"Street","select-country":"Land","field-zip-code":"Postleitzahl","field-city":"Ort","field-language":"Sprache"},"en":{},"it":{},"fr":{}}')
  delete Component.options._Ctor
}
